var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3575_4709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4253 0.990234C6.79727 0.990234 7.17288 0.990234 7.54485 0.990234C7.55215 1.01941 7.57767 1.01576 7.59955 1.01576C7.85483 1.034 8.10645 1.07046 8.35443 1.12152C11.2718 1.70135 13.489 4.02797 13.923 6.95631C13.9449 7.11312 13.9376 7.27722 13.9959 7.43038C13.9959 7.80235 13.9959 8.17797 13.9959 8.54993C13.9522 8.56452 13.9704 8.60463 13.9668 8.63016C13.9339 8.94014 13.8865 9.25011 13.8136 9.55643C12.9129 13.3016 9.27706 15.5991 5.50632 14.8005C2.68374 14.2024 0.477464 11.8466 0.0726754 9.00942C0.0507949 8.85626 0.0617351 8.6958 -0.00390625 8.54993C-0.00390625 8.15973 -0.00390625 7.76588 -0.00390625 7.37568C0.0398547 7.36109 0.021621 7.32463 0.0252677 7.29545C0.0580884 6.99642 0.101849 6.70103 0.171137 6.4093C0.845785 3.58307 3.09947 1.50807 5.9804 1.06317C6.12627 1.04129 6.28308 1.05223 6.4253 0.990234ZM7.71625 8.99848C7.71625 8.44053 7.7126 7.87893 7.7199 7.32098C7.72354 7.11312 7.63237 6.98548 7.45368 6.90525C7.213 6.79585 6.96137 6.78856 6.7061 6.85055C6.38883 6.92713 6.29037 7.05842 6.29037 7.37568C6.29037 8.46971 6.29402 9.56738 6.28673 10.6614C6.28673 10.8547 6.36331 10.986 6.52376 11.0698C6.85197 11.2412 7.18018 11.2339 7.50109 11.0516C7.65061 10.9677 7.7199 10.8401 7.71625 10.6578C7.70896 10.1071 7.71625 9.55279 7.71625 8.99848ZM7.00149 5.96439C7.18747 5.96439 7.35522 5.90604 7.4938 5.79299C7.8293 5.52314 7.822 5.07094 7.48286 4.81202C7.18018 4.58228 6.73163 4.60051 6.45083 4.85578C6.18826 5.09282 6.17368 5.46114 6.41436 5.71641C6.57482 5.88781 6.77174 5.96439 7.00149 5.96439Z",
    fill: "#AAA4C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3575_4709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9998,
    height: 13.967,
    fill: "white",
    transform: "translate(0 0.990234)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutus);
export default __webpack_public_path__ + "static/media/aboutus.e201cd7bdcde2cfc99b3122e3d12a2cf.svg";
export { ForwardRef as ReactComponent };